import { styled, Typography, Button } from '@mui/material';
import { Box } from '@mui/system';
import { IconCircleCheck, IconXClose } from '@shared/assets/images/svgs';
import { t } from 'i18next';
import React from 'react';
import { ToastContentProps } from 'react-toastify';

interface ToastContentDataType {
  title: string;
  description: string;
  onUndo?: () => void;
  undoLabel?: string;
}

const IconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '42px',
  height: '42px',
  backgroundColor: theme.palette.success.light,
}));

export const CustomSuccessToast = (
  toastContentProps: ToastContentProps & { data: ToastContentDataType },
): React.ReactElement => {
  const { closeToast, data } = toastContentProps;

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          minHeight: '42px',
          alignItems: 'center',
        }}>
        <IconWrapper>
          <IconCircleCheck />
        </IconWrapper>
        <Box display="flex" flexDirection="column" px={1.5} py={0.5} flex={1}>
          <Typography variant="subtitle1" fontSize="12px" color="text.primary" fontWeight={600}>
            {data?.title || t('campaignPage.savedCampaignToastTitle')}
          </Typography>
          <Typography variant="body1" color="text.primary" fontSize="12px">
            {data?.description || t('campaignPage.savedCampaignToastBody')}
          </Typography>
        </Box>
        {data?.onUndo && (
          <Button
            size="small"
            onClick={() => {
              data.onUndo?.();
              closeToast?.();
            }}
            sx={{
              mr: 1,
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '12px',
              color: 'primary.main',
            }}>
            {data.undoLabel || t('common.undo')}
          </Button>
        )}
      </Box>
      <Box
        sx={{
          position: 'absolute',
          right: '10px',
          top: '10px',
          cursor: 'pointer',
        }}
        onClick={() => closeToast()}>
        <IconXClose />
      </Box>
    </>
  );
};
